<template>
  <section class="Discover py-5">
    <div class="container">
      <div class="_title pb-md-8" v-if="homeSetting.studios_cities_title">
        <div class="label-div">
          <i class="mdi mdi-circle"></i>&nbsp;
          {{ $t('discover-spaces-by-city') }}
        </div>
        <h1>{{ homeSetting.studios_cities_title }}</h1>
        <span v-html="homeSetting.studios_cities_description"></span>
      </div>
      <div v-else class="py-16">
        <v-skeleton-loader class="bg-transparent mx-auto" type="article" width="500"></v-skeleton-loader>
      </div>

      <div class="row" v-if="cities.length > 0">
        <div style="direction: rtl;">
          <carousel v-bind="options">
            <slide class="slide-item" v-for="city in cities" :key="city.id">
              <a @click="openCity(city.id, homeSetting.if_show_cities_filter)">
                <div class="category_item">
                  <div class="card custom-section-div">
                    <img class="card-img" :src="city.image_url" :alt="city.name"/>
                    <p class="card-title">
                      {{ city.name }}
                      <!--                      <span class="font-weight-bold">{{ city.name }}</span>-->
                      <!--                      {{ city.spaces_count }} {{ $t('unit') }}-->
                    </p>
                  </div>
                </div>
              </a>
            </slide>
          </carousel>
        </div>
      </div>
      <div v-else class="row">
        <v-col cols="12" md="3" v-for="i in 4" :key="i">
          <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
        </v-col>
      </div>

      <v-dialog v-model="dialog" width="600px" class="modal_auth">
        <v-card class="dialog_auth" style="height: 500px;">
          <v-container class="px-8">
            <div class="text-end mb-8">
              <a href="javascript:void(0);" @click.prevent="dialog = false">
                <i class="mdi mdi-close mdi-18px"></i>
              </a>
            </div>
            <div class="filter_projects text-start">
              <template>
                <div class="d-flex justify-content-between mb-2">
                  <label>{{ $t('filterProject.category') }}</label>
                  <button @click="toggleCloseMenu" class="btn btn-dark px-8" v-if="chooseDoneShow">
                    <i class="mdi mdi-check-all"></i>&nbsp;&nbsp;{{ $t('choose-done') }}
                  </button>
                </div>
              </template>
              <v-select
                  :items="categories"
                  :item-text="(sec) => sec.name"
                  :item-value="(sec) => sec.id"
                  v-model="filter.categoriesVal"
                  multiple filled solo :label="$t('filterProject.category')" prepend-inner-slot
                  :menu-props="{closeOnClick: closeOnClick,closeOnContentClick: closeOnClick}"
                  :no-data-text="$t('no-data')"
                  @click="chooseDoneShow = true;">
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="toggleCheckAll">
                    <v-list-item-action>
                      <v-icon>{{ icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t('choose-all') }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>

              <label class="mb-2">{{ $t('studios.StartDate') }}</label>
              <v-menu :close-on-content-click="true" :nudge-right="0" transition="scale-transition"
                      offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="filter.add_date" :placeholder="$t('choose-date')"
                                readonly filled solo v-bind="attrs"
                                v-on="on" style="border: none;">
                    <template #prepend-inner>
                      <v-icon color="#4D4D4D" style="margin-inline-end: 10px;">mdi-calendar</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker :locale="lang" v-model="filter.add_date"
                               :min="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)"
                ></v-date-picker>
              </v-menu>

              <div class="text-center">
                <button @click="search" class="btn btn-dark mt-16 w-50">
                  {{ $t("filterProject.search") }}
                </button>
              </div>
            </div>
          </v-container>
        </v-card>
      </v-dialog>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  props: ["cities", "homeSetting"],
  data() {
    return {
      dialog: false,
      lang: localStorage.getItem('lang') || 'ar',
      categories: [],
      filter: {
        citiesVal: [],
        categoriesVal: [],
        add_date: '',
      },
      closeOnClick: false,
      chooseDoneShow: false,
      options: {
        loop: true,
        margin: 5,
        perPage: 1,
        center: true,
        centerMode: true,
        autoplay: true,
        autoplayTimeout: 3000,
        paginationEnabled: false,
        autoplayHoverPause: true,
        navigationEnabled: true,
        paginationColor: "#555",
        paginationActiveColor: "#9f762b",
        paginationSize: 5,
        rtl: true,
        perPageCustom: [
          [0, 1],
          [375, 1.25],
          [425, 1.5],
          [500, 1.75],
          [768, 2.5],
          [960, 3],
          [1264, 4.25],
          [1440, 4.75],
        ],
      },
    };
  },
  created() {
    axios.get("categories", {})
        .then(({data}) => {
          this.categories = data.data;
        });
  },
  computed: {
    checkAllCategories() {
      return this.filter.categoriesVal.length === this.categories.length
    },
    checkSomeCategories() {
      return this.filter.categoriesVal.length > 0 && !this.checkAllCategories
    },
    icon() {
      if (this.checkAllCategories) return 'mdi-close-box'
      if (this.checkSomeCategories) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  methods: {
    openCity(cityId, ifShowCitiesFilter) {
      this.filter.citiesVal = [cityId];
      this.dialog = (ifShowCitiesFilter === 'yes');
      if (ifShowCitiesFilter === 'no') {
        this.search();
      }
    },
    search() {
      this.$router.push({
        name: 'studios',
        query: this.filter
      });
    },
    toggleCheckAll() {
      this.$nextTick(() => {
        if (this.checkAllCategories) {
          this.filter.categoriesVal = [];
        } else {
          this.filter.categoriesVal = this.categories.map(a => a.id);
        }
      })
    },
    toggleCloseMenu() {
      this.chooseDoneShow = false;
      this.closeOnClick = true;
      setTimeout(() => {
        this.closeOnClick = false;
      }, 100);
    }
  },
};
</script>

<style scoped lang="scss">
.Discover {
  margin: 60px 0 90px 0;

  ._title {
    h1 {
      color: #000;
      font-size: 48px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
      letter-spacing: -1.536px;
      margin-bottom: 24px;
    }

    span {
      color: #727272;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }
  }

  @media (max-width: 768px) {
    margin: 0;
    ._title {
      h1 {
        font-size: 24px;
        font-weight: 700;
        line-height: 32px;
      }

      span {
        font-weight: 600;
      }
    }
  }

  .VueCarousel-slide:nth-child(odd) {
    margin-top: 100px;
  }

  .custom-section-div {
    overflow: hidden;
    text-align: center;
    border-radius: 12px;
    border: 3px solid #FFF;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    width: fit-content;
  }

  .custom-section-div:before {
    content: '';
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%);
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
  }

  .custom-section-div:hover:before {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.40) 100%);
    transition: 300ms ease-in-out;
  }

  .custom-section-div .card-img {
    object-fit: cover;
    border-radius: 12px;
    width: 250px;
    height: 275px;
  }

  .custom-section-div .card-title {
    border-radius: 8px;
    padding: 4px 8px;
    background: rgba(0, 0, 0, 0.40);
    color: #F4F4F4;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .custom-section-div .card-title p {
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 26px;
    color: #F4F4F4;
  }

  @media (max-width: 768px) {
    .VueCarousel-slide:nth-child(odd) {
      margin-top: 0;
    }
    .custom-section-div .card-title p {
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
    }
  }
}
</style>
<style>
.VueCarousel-wrapper {
  padding: 24px 0;
}

.VueCarousel-navigation {
  position: absolute;
  top: unset;
  bottom: -50px;
}

.VueCarousel-navigation-button {
  border-radius: 6px;
  border: 3px solid #DBDBDB !important;
  background: #FFF !important;
  width: 93px;
  height: 43px;
  box-shadow: none;
  font-size: 0; /* hides ▶ visually */
  padding: 0 !important;
}

.VueCarousel-navigation-button:hover {
  background: #DBDBDB !important;
  transition: 300ms ease-in-out;
}

.Discover .VueCarousel-navigation-next {
  right: calc(50% + 2px) !important;
}

.Discover .VueCarousel-navigation-prev {
  left: calc(50% + 2px) !important;
}

.VueCarousel-navigation-next:after,
.VueCarousel-navigation-prev:after {
  color: #000 !important;
  position: absolute;
  top: calc(50% - 10px);
  left: calc(50% - 10px);
  background-color: transparent;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  font-family: "IBM Plex Sans Arabic", sans-serif; /* Exact name */
  display: inline-flex;
  justify-content: center;
}

.VueCarousel-navigation-next:after {
  /*
  content: '\F0054 السابق';
  direction: rtl;
  */

  content: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='13' height='11' viewBox='0 0 13 11' fill='none'><path d='M11.8355 5.08664L7.85324 1.10437C7.72856 0.97968 7.55945 0.909632 7.38311 0.909632C7.20678 0.909632 7.03767 0.979679 6.91298 1.10437C6.7883 1.22905 6.71825 1.39816 6.71825 1.5745C6.71825 1.75083 6.7883 1.91994 6.91298 2.04463L9.76197 4.89251L1.63149 4.89251C1.45546 4.89251 1.28664 4.96243 1.16217 5.0869C1.0377 5.21137 0.967774 5.38019 0.967774 5.55622C0.967774 5.73225 1.0377 5.90107 1.16217 6.02554C1.28664 6.15001 1.45546 6.21993 1.63149 6.21993L9.76197 6.21993L6.91409 9.06947C6.7894 9.19416 6.71935 9.36327 6.71935 9.5396C6.71935 9.71594 6.7894 9.88505 6.91409 10.0097C7.03877 10.1344 7.20788 10.2045 7.38422 10.2045C7.56055 10.2045 7.72966 10.1344 7.85435 10.0097L11.8366 6.02746C11.8985 5.96571 11.9476 5.89235 11.981 5.81159C12.0145 5.73082 12.0317 5.64424 12.0316 5.55682C12.0315 5.4694 12.0141 5.38286 11.9804 5.30218C11.9468 5.22149 11.8976 5.14824 11.8355 5.08664Z' fill='currentColor'/></svg>") " السابق";
  display: contents;
}

[lang='en'] .VueCarousel-navigation-next:after {
  content: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='13' height='11' viewBox='0 0 13 11' fill='none'><path d='M11.8355 5.08664L7.85324 1.10437C7.72856 0.97968 7.55945 0.909632 7.38311 0.909632C7.20678 0.909632 7.03767 0.979679 6.91298 1.10437C6.7883 1.22905 6.71825 1.39816 6.71825 1.5745C6.71825 1.75083 6.7883 1.91994 6.91298 2.04463L9.76197 4.89251L1.63149 4.89251C1.45546 4.89251 1.28664 4.96243 1.16217 5.0869C1.0377 5.21137 0.967774 5.38019 0.967774 5.55622C0.967774 5.73225 1.0377 5.90107 1.16217 6.02554C1.28664 6.15001 1.45546 6.21993 1.63149 6.21993L9.76197 6.21993L6.91409 9.06947C6.7894 9.19416 6.71935 9.36327 6.71935 9.5396C6.71935 9.71594 6.7894 9.88505 6.91409 10.0097C7.03877 10.1344 7.20788 10.2045 7.38422 10.2045C7.56055 10.2045 7.72966 10.1344 7.85435 10.0097L11.8366 6.02746C11.8985 5.96571 11.9476 5.89235 11.981 5.81159C12.0145 5.73082 12.0317 5.64424 12.0316 5.55682C12.0315 5.4694 12.0141 5.38286 11.9804 5.30218C11.9468 5.22149 11.8976 5.14824 11.8355 5.08664Z' fill='currentColor'/></svg>") ' prev';
}

.VueCarousel-navigation-prev:after {
  /*
  content: '\F004D التالي';
  direction: ltr;
  */
  content: "التالي " url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='13' height='11' viewBox='0 0 13 11' fill='none'><path d='M1.16448 5.08664L5.14676 1.10436C5.27144 0.97968 5.44055 0.909631 5.61689 0.909631C5.79322 0.909631 5.96233 0.979679 6.08702 1.10436C6.2117 1.22905 6.28175 1.39816 6.28175 1.5745C6.28175 1.75083 6.2117 1.91994 6.08702 2.04463L3.23803 4.89251L11.3685 4.89251C11.5445 4.89251 11.7134 4.96243 11.8378 5.0869C11.9623 5.21137 12.0322 5.38019 12.0322 5.55622C12.0322 5.73225 11.9623 5.90107 11.8378 6.02554C11.7134 6.15001 11.5445 6.21993 11.3685 6.21993L3.23803 6.21993L6.08591 9.06947C6.2106 9.19416 6.28065 9.36327 6.28065 9.5396C6.28065 9.71594 6.2106 9.88505 6.08591 10.0097C5.96123 10.1344 5.79212 10.2045 5.61578 10.2045C5.43945 10.2045 5.27034 10.1344 5.14565 10.0097L1.16337 6.02746C1.10149 5.96571 1.05241 5.89235 1.01895 5.81159C0.985502 5.73082 0.968334 5.64424 0.968437 5.55682C0.96854 5.4694 0.985911 5.38286 1.01955 5.30218C1.0532 5.22149 1.10245 5.14824 1.16448 5.08664Z' fill='currentColor'/></svg>");
  display: contents;
}

[lang='en'] .VueCarousel-navigation-prev:after {
  content: 'next ' url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='13' height='11' viewBox='0 0 13 11' fill='none'><path d='M1.16448 5.08664L5.14676 1.10436C5.27144 0.97968 5.44055 0.909631 5.61689 0.909631C5.79322 0.909631 5.96233 0.979679 6.08702 1.10436C6.2117 1.22905 6.28175 1.39816 6.28175 1.5745C6.28175 1.75083 6.2117 1.91994 6.08702 2.04463L3.23803 4.89251L11.3685 4.89251C11.5445 4.89251 11.7134 4.96243 11.8378 5.0869C11.9623 5.21137 12.0322 5.38019 12.0322 5.55622C12.0322 5.73225 11.9623 5.90107 11.8378 6.02554C11.7134 6.15001 11.5445 6.21993 11.3685 6.21993L3.23803 6.21993L6.08591 9.06947C6.2106 9.19416 6.28065 9.36327 6.28065 9.5396C6.28065 9.71594 6.2106 9.88505 6.08591 10.0097C5.96123 10.1344 5.79212 10.2045 5.61578 10.2045C5.43945 10.2045 5.27034 10.1344 5.14565 10.0097L1.16337 6.02746C1.10149 5.96571 1.05241 5.89235 1.01895 5.81159C0.985502 5.73082 0.968334 5.64424 0.968437 5.55682C0.96854 5.4694 0.985911 5.38286 1.01955 5.30218C1.0532 5.22149 1.10245 5.14824 1.16448 5.08664Z' fill='currentColor'/></svg>");
}
</style>
